import TripRoute from "./TripRoute";

export default TripRoute;
